<script>
	import SignUp from './SignUp.svelte';
	
	let dialogOpened = false;
</script>

<div>
  <button on:click={() => dialogOpened = true}>Tell me when it launches</button>
</div>

<SignUp bind:showing={dialogOpened}/>

<style>
  div {
    text-align: center;
  }
  
  button {
    border: none;
    border-radius: .5rem;
    padding: 1rem 2rem;
    background: var(--a1-c);
    color: var(--a1-b);
    font-weight: bold;
    font-size: 1.5rem;
    font-family: var(--ff-1);
    cursor: pointer;
    transition: .2s;
  }

  button:is(:hover,:focus) {
    box-shadow: .25rem .25rem 1px var(--fg-1);
  }
</style>